module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "orders-people-associated"
  }, [_c('div', {
    staticClass: "assiciated-list"
  }, [_c('ul', [_c('li', [_vm._v("Joe smith")]), _vm._v(" "), _c('li', [_vm._v("BorisOliviero")]), _vm._v(" "), _c('li', [_vm._v("Joe smith")]), _vm._v(" "), _c('li', [_vm._v("BorisOliviero")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f341ab0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/order-common/order-people-associated.vue
// module id = 3103
// module chunks = 0